import React, { useCallback } from "react";
import {
  StoreFilesScreenComponent,
  onPressIntegrationFileType,
} from "../Files/FilesScreenComponent";
import { useOpenFile } from "../Files/useOpenFile";
import { TeamTabNavigationProp, TeamTabRouteProp } from "./TeamTab";

type Props = {
  navigation: TeamTabNavigationProp<"TeamFiles">;
  route: TeamTabRouteProp<"TeamFiles">;
};

export function TeamFiles(props: Props) {
  const openFile = useOpenFile();
  const onShowAllFiles = useCallback(() => {
    props.navigation.navigateDeprecated("Files", {
      screen: "AllFiles",
      params: { teamId: props.route.params.teamId, standalone: true },
    });
  }, [props.navigation, props.route.params.teamId]);
  const onPressIntegrationFile: onPressIntegrationFileType = useCallback(
    ({ id, title }) => {
      props.navigation.navigateDeprecated("EmaginWebview", {
        eMaginId: id,
        title,
      });
    },
    [props.navigation]
  );
  return (
    <StoreFilesScreenComponent
      onShowAllFiles={onShowAllFiles}
      includeIntegrationFiles
      onPressFile={openFile}
      onPressIntegrationFile={onPressIntegrationFile}
    />
  );
}
